
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9xEYQ", function(module, exports) {
$parcel$export(module.exports, "SubNav", function () { return $1af96c5497bd4dda$export$4a51633636d7017c; });
/* subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $9KOR3 = parcelRequire("9KOR3");

var $fe44n = parcelRequire("fe44n");
const $1af96c5497bd4dda$var$navigationBarWrapperCss = null;
// @ts-ignore
const $1af96c5497bd4dda$var$navBarShadow = null;
const $1af96c5497bd4dda$var$navigationBarLogoCss = null;
const $1af96c5497bd4dda$var$textWrapperCss = null;
const $1af96c5497bd4dda$var$textCss = null;
// @ts-ignore
const $1af96c5497bd4dda$var$ffTextCss = null;
const $1af96c5497bd4dda$var$mobileNavCss = null;
const $1af96c5497bd4dda$var$subNavCss = null;
const $1af96c5497bd4dda$export$4f1b8c6dfaa906bb = ({ productKey: productKey, headerLinkText: headerLinkText, headerLinkHref: headerLinkHref, desktopLinks: desktopLinks })=>{
    const globalLinksRef = (0, $1oC0p.useRef)(null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_mqm21k0a _4cvr1h6o _11q7cd5j _1e0c1txw _4t3it9kd _2lx2vrvc _1bah1h6o _1pbykb7n _1mjbglyw",
            "desktop-sub-nav"
        ]),
        style: {
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0cglyw _4cvr1h6o _1bah1h6o _16jlkb7n _1o9zkb7n _i0dlf1ug _18zr1ylp _2lx2vrvc _kqswh2mm _1pbyegat _195g1tcg _dm251txw _10jxtfvk _owpuidpf _165t1osq _xtn71wqb",
                "sub-navigation-bar"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("nav", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4t3i1osq _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _glte1wug",
                            "navigation-bar-logo"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-testid": "sub-navigation-bar-logo-link",
                            href: headerLinkHref,
                            "aria-label": headerLinkText,
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "subNavWac",
                            "data-product-key": productKey,
                            className: (0, $2jatx.default)([
                                "_4t3i1osq _syaz1hlo _4cvr1h6o _1e0c1txw _2lx2vrvc"
                            ]),
                            style: {
                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1k92 _k48pni7l"
                                ]),
                                children: headerLinkText
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.default), {
                        globalLinksProps: desktopLinks,
                        globalLinksRef: globalLinksRef,
                        isSubnav: true
                    })
                ]
            })
        })
    });
};
const $1af96c5497bd4dda$export$4a51633636d7017c = ({ productKey: productKey, headerLinkText: headerLinkText, headerLinkHref: headerLinkHref, desktopLinks: desktopLinks, mobileLinks: mobileLinks })=>{
    const globalNavItemKeys = (0, $1oC0p.useMemo)(()=>{
        return desktopLinks.map((link)=>link.globalLinksKey);
    }, [
        desktopLinks
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "subnav",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqsw1if8 _1pbykb7n _152t8vuz _12ho1ex1 _180k88uy"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavProvider), {
                    globalNavItemKeys: globalNavItemKeys,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($1af96c5497bd4dda$export$4f1b8c6dfaa906bb, {
                        productKey: productKey,
                        headerLinkText: headerLinkText,
                        headerLinkHref: headerLinkHref,
                        desktopLinks: desktopLinks
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0cglyw _1mjb1ule",
                        "mobile-nav"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fe44n.MobileSubNav), {
                        productKey: productKey,
                        headerLinkText: headerLinkText,
                        headerLinkHref: headerLinkHref,
                        isShowSearchButton: false,
                        mobileLinks: mobileLinks
                    })
                })
            ]
        })
    });
};
$1af96c5497bd4dda$export$4a51633636d7017c.displayName = "SubNav";

});
parcelRegister("fe44n", function(module, exports) {
$parcel$export(module.exports, "MobileSubNav", function () { return $ad98c345a8e6e64b$export$7b30ebdb7f5cc633; });
/* subnav-mobile.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $hiOEV = parcelRequire("hiOEV");

var $3PWZ2 = parcelRequire("3PWZ2");

var $3R5TL = parcelRequire("3R5TL");

var $5CDBA = parcelRequire("5CDBA");

var $atObq = parcelRequire("atObq");

var $eRC2p = parcelRequire("eRC2p");
const $ad98c345a8e6e64b$var$containerCss = null;
// @ts-ignore
const $ad98c345a8e6e64b$var$navBarShadow = null;
const $ad98c345a8e6e64b$var$shownInnerMobileDropdownMenuStyle = null;
const $ad98c345a8e6e64b$var$hiddenInnerMobileDropdownMenuStyle = null;
const $ad98c345a8e6e64b$var$menuContentStyle = null;
const $ad98c345a8e6e64b$var$containerClosedCss = null;
const $ad98c345a8e6e64b$var$containerOpenCss = null;
const $ad98c345a8e6e64b$var$navBarClosedCss = null;
// @ts-ignore
const $ad98c345a8e6e64b$var$alignNavBarText = null;
const $ad98c345a8e6e64b$var$navBarOpenCss = null;
const $ad98c345a8e6e64b$var$fadeIn = null;
const $ad98c345a8e6e64b$var$slideInLeft = null;
const $ad98c345a8e6e64b$var$slideInRight = null;
const $ad98c345a8e6e64b$var$fadeInCss = null;
const $ad98c345a8e6e64b$var$slideInLeftCss = null;
const $ad98c345a8e6e64b$var$slideInRightCss = null;
const $ad98c345a8e6e64b$export$e0ff47c11cc5d411 = ({ menuPage: menuPage = "default", firstOpen: firstOpen, mobileLinksSections: mobileLinksSections, handleMenuPage: handleMenuPage })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    firstOpen && "",
                    firstOpen && "_tzy4idpf _y44v10k4",
                    !firstOpen && "",
                    !firstOpen && "_tzy4idpf _y44vydmd",
                    menuPage === "default" ? "_1e0c1ule _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz" : "_1e0cglyw _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz",
                    "inner-mobile-dropdown-menu"
                ]),
                children: mobileLinksSections.map(({ mobileLinkKey: mobileLinkKey, mobileLinksProps: mobileLinksProps }, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $3R5TL.MobileNavLinksContainer), {
                        mobileLinkKey: mobileLinkKey,
                        mobileLinksProps: mobileLinksProps,
                        handleMenuPage: handleMenuPage,
                        isIncludeBottomDivider: false
                    }, index))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_tzy4idpf _y44vm8zv",
                    menuPage === "devops" ? "_1e0c1ule _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz" : "_1e0cglyw _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $atObq.DevopsDropdown), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_tzy4idpf _y44vm8zv",
                    menuPage === "categories" ? "_1e0c1ule _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz" : "_1e0cglyw _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5CDBA.CategoriesDropdown), {})
            })
        ]
    });
};
const $ad98c345a8e6e64b$var$textWrapperCss = null;
const $ad98c345a8e6e64b$var$textCss = null;
// @ts-ignore
const $ad98c345a8e6e64b$var$ffTextCss = null;
const $ad98c345a8e6e64b$export$7b30ebdb7f5cc633 = ({ headerLinkText: headerLinkText, headerLinkHref: headerLinkHref, productKey: productKey, mobileLinks: mobileLinks })=>{
    const { userInfo: userInfo, showMenu: showMenu, firstOpen: firstOpen, menuPage: menuPage, handleToggleMenu: handleToggleMenu, handleFirstOpen: handleFirstOpen, handleMenuPage: handleMenuPage } = (0, $hiOEV.useMobileNavDisplay)(false);
    const headerLink = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4t3i1osq _syaz1hlo _4cvr1h6o _1e0c1txw _2lx2vrvc"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            className: (0, $2jatx.default)([
                "_1wyb1k92 _ca0q1ou6 _u5f37vkz _n3tdgktf _19bvidpf _k48pni7l"
            ]),
            children: headerLinkText
        })
    });
    const mobileGlobalNavDropdownMenu = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)($ad98c345a8e6e64b$export$e0ff47c11cc5d411, {
            showMenu: showMenu,
            isUserLoggedIn: userInfo.isUserLoggedIn,
            menuPage: menuPage,
            firstOpen: firstOpen,
            mobileLinksSections: mobileLinks,
            handleToggleMenu: handleToggleMenu,
            handleMenuPage: handleMenuPage,
            handleFirstOpen: handleFirstOpen,
            productKey: productKey
        });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_mqm21k0a _152t8vuz _11q7cd5j _1e0c1txw _2lx21bp4 _zulputpp _4t3i1mcy _1bah1h6o",
            showMenu ? "_ca0qftgi _u5f3ftgi _n3tdftgi _19bvftgi _tnru1kxc _1rfm1osq _1o831wug _98bk1wug _13zm1n9t _1kmxftgi _1ggm1tcg _1ykz1tcg _1mae1tcg _2rfoqfx8" : "_ca0qftgi _u5f3ftgi _n3tdftgi _19bvftgi"
        ]),
        style: {
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    showMenu ? "_su07pxbi _1e0c1txw _4cvr1h6o _1bah1yb4" : "_18zrpxbi _1e0c1txw _1bah1yb4"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eRC2p.MobileSubNavTop), {
                    productKey: productKey,
                    showMenu: showMenu,
                    handleToggleMenu: handleToggleMenu,
                    menuPage: menuPage,
                    handleMenuPage: handleMenuPage,
                    handleFirstOpen: handleFirstOpen,
                    mobileLogo: headerLink,
                    mobileLogoAriaLabel: headerLinkText,
                    mobileLogoHref: headerLinkHref,
                    mobileLogoDataEventContainer: "subNavWac",
                    tabletDropdownMenu: mobileGlobalNavDropdownMenu()
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                id: "nav-mobile-dropdown-menu",
                className: (0, $2jatx.default)([
                    "_1e0cglyw _1bsb1wug _181nglyw",
                    showMenu && "_1e0c1ule"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3PWZ2.Divider), {})
                    }),
                    mobileGlobalNavDropdownMenu()
                ]
            })
        ]
    });
};

});
parcelRegister("5CDBA", function(module, exports) {
$parcel$export(module.exports, "CategoriesDropdown", function () { return $f0975b206043c4ea$export$abcf464d25ebdb87; });
/* subnav-categories-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");
const $f0975b206043c4ea$var$wrapperStyle = null;
const $f0975b206043c4ea$var$headerStyle = null;
const $f0975b206043c4ea$var$linkColumnStyle = null;
const $f0975b206043c4ea$var$linkStyle = null;
const $f0975b206043c4ea$var$CategoriesDropdownContentSection = ({ header: header, links: links })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                },
                children: header
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _umai1ylp _1bsbntd2"
                ]),
                children: links.map((link)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                        href: link.href,
                        "data-event": "clicked",
                        "data-event-component": "linkButton",
                        "data-event-container": "Sub-Nav-link-in-dropdown",
                        onClick: link.onClick,
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1hlo _1wyboxwj _1wpzh9n0 _30l317la"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                        },
                        children: link.text
                    }, link.text))
            })
        ]
    });
};
const $f0975b206043c4ea$export$abcf464d25ebdb87 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)($f0975b206043c4ea$var$CategoriesDropdownContentSection, {
        header: intl.formatMessage({
            id: "jira-templates.subnav.categories.type.header",
            defaultMessage: "categories"
        }),
        links: [
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.software-development",
                    defaultMessage: "Software Development"
                }),
                href: (0, $kooLp.useLocalizedHref)("/software/jira/templates/software-development")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.marketing",
                    defaultMessage: "Marketing"
                }),
                href: (0, $kooLp.useLocalizedHref)("/software/jira/templates/marketing")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.design",
                    defaultMessage: "Design"
                }),
                href: (0, $kooLp.useLocalizedHref)("/software/jira/templates/design")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.sales",
                    defaultMessage: "Sales"
                }),
                href: (0, $kooLp.useLocalizedHref)("/software/jira/templates/sales")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.operations",
                    defaultMessage: "Operations"
                }),
                href: (0, $kooLp.useLocalizedHref)("/software/jira/templates/operations")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.service-management",
                    defaultMessage: "Service Management"
                }),
                href: (0, $kooLp.useLocalizedHref)("/software/jira/templates/service-management")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.hr",
                    defaultMessage: "HR"
                }),
                href: (0, $kooLp.useLocalizedHref)("/software/jira/templates/hr")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.legal",
                    defaultMessage: "Legal"
                }),
                href: (0, $kooLp.useLocalizedHref)("/software/jira/templates/legal")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.it-operations",
                    defaultMessage: "IT Operations"
                }),
                href: (0, $kooLp.useLocalizedHref)("/software/jira/templates/it-operations")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.finance",
                    defaultMessage: "Finance"
                }),
                href: (0, $kooLp.useLocalizedHref)("/software/jira/templates/finance")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.project-management",
                    defaultMessage: "Project Management"
                }),
                href: (0, $kooLp.useLocalizedHref)("/project-management/templates")
            }
        ]
    }, "categories");
};

});

parcelRegister("atObq", function(module, exports) {
$parcel$export(module.exports, "DevopsDropdown", function () { return $335083b1a809ea91$export$14a5b297e74877f3; });
/* subnav-devops-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");
const $335083b1a809ea91$var$wrapperStyle = null;
const $335083b1a809ea91$var$headerStyle = null;
const $335083b1a809ea91$var$linkColumnStyle = null;
const $335083b1a809ea91$var$linkStyle = null;
const $335083b1a809ea91$var$DevopsDropdownContentSection = ({ header: header, links: links })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                },
                children: header
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _umai1ylp _1bsbntd2"
                ]),
                children: links.map((link)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                        href: link.href,
                        "data-event": "clicked",
                        "data-event-component": "linkButton",
                        "data-event-container": "Sub-Nav-link-in-dropdown",
                        onClick: link.onClick,
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1hlo _1wyboxwj _1wpzh9n0 _30l317la"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                        },
                        children: link.text
                    }, link.text))
            })
        ]
    });
};
const $335083b1a809ea91$export$14a5b297e74877f3 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)($335083b1a809ea91$var$DevopsDropdownContentSection, {
        header: intl.formatMessage({
            id: "software-development.subnav.devops.type.header",
            defaultMessage: "devops"
        }),
        links: [
            {
                text: intl.formatMessage({
                    id: "software-development.subnav.devops.type.continuous-delivery",
                    defaultMessage: "Continuous Delivery"
                }),
                href: (0, $kooLp.useLocalizedHref)("/continuous-delivery")
            },
            {
                text: intl.formatMessage({
                    id: "software-development.subnav.devops.type.git",
                    defaultMessage: "Git"
                }),
                href: (0, $kooLp.useLocalizedHref)("/git")
            }
        ]
    }, "devops");
};

});

parcelRegister("eRC2p", function(module, exports) {
$parcel$export(module.exports, "MobileSubNavTop", function () { return $534ac3b9543612a5$export$4dbd6629097ee82e; });
/* subnav-mobile-top.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $7IesZ = parcelRequire("7IesZ");
const $534ac3b9543612a5$var$mobileLogoCss = null;
const $534ac3b9543612a5$var$tabletLogoCss = null;
const $534ac3b9543612a5$var$logoCss = null;
const $534ac3b9543612a5$var$backButtonCss = null;
const $534ac3b9543612a5$var$chevronCss = null;
const $534ac3b9543612a5$var$mobileIconContainerCss = null;
const $534ac3b9543612a5$var$mobileDropdownMenuCss = null;
const $534ac3b9543612a5$var$tabletIconContainerCss = null;
const $534ac3b9543612a5$var$dropdownCss = null;
const $534ac3b9543612a5$export$4dbd6629097ee82e = ({ productKey: productKey, showMenu: showMenu, handleToggleMenu: handleToggleMenu, menuPage: menuPage, handleMenuPage: handleMenuPage, handleFirstOpen: handleFirstOpen, mobileLogo: mobileLogo, mobileLogoAriaLabel: mobileLogoAriaLabel = "Atlassian logo", mobileLogoHref: mobileLogoHref = "/", mobileLogoDataEventContainer: mobileLogoDataEventContainer = "subNavWac", tabletDropdownMenu: tabletDropdownMenu })=>{
    const intl = (0, $8e22h.default)();
    const [mobileDropdownMenu, setMobileDropdownMenu] = (0, $1oC0p.useState)(null);
    const handleClickOutside = (0, $1oC0p.useCallback)((event)=>{
        const path = event.composedPath && event.composedPath();
        if (mobileDropdownMenu) {
            const style = window.getComputedStyle(mobileDropdownMenu);
            const insideTabletMobileDropdownMenu = Array.prototype.includes.call(Array.prototype.map.call(path, (el)=>{
                return el.id === "nav-tablet-mobile-dropdown-menu-button";
            }), true);
            if (!insideTabletMobileDropdownMenu && style.display !== "none") {
                handleToggleMenu(false);
                handleMenuPage("default");
                handleFirstOpen(false);
            }
        }
    }, [
        mobileDropdownMenu,
        handleToggleMenu,
        handleMenuPage,
        handleFirstOpen
    ]);
    const handleKeydown = (0, $1oC0p.useCallback)((event)=>{
        if (event.code == "Escape" && showMenu) {
            handleToggleMenu(false);
            handleMenuPage("default");
            handleFirstOpen(false);
        }
    }, [
        handleToggleMenu,
        handleMenuPage,
        handleFirstOpen,
        showMenu
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const element = document.getElementById("nav-tablet-mobile-dropdown-menu-button");
        setMobileDropdownMenu(element);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        document.addEventListener("click", handleClickOutside);
        document.addEventListener("keydown", handleKeydown);
        return ()=>{
            document.removeEventListener("click", handleClickOutside);
            document.removeEventListener("keydown", handleKeydown);
        };
    }, [
        handleClickOutside,
        handleKeydown
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _181nglyw",
                    "mobile-nav-company-logo"
                ]),
                children: menuPage === "default" || !showMenu ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                    href: mobileLogoHref,
                    "aria-label": mobileLogoAriaLabel,
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": mobileLogoDataEventContainer,
                    "data-product-key": productKey,
                    className: (0, $2jatx.default)([
                        "_4t3i183y"
                    ]),
                    children: mobileLogo
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    style: {
                        all: "unset",
                        width: "100%"
                    },
                    onClick: (e)=>{
                        e.preventDefault();
                        handleMenuPage("default");
                        handleFirstOpen(false);
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_syazaqb7 _1e0c1txw _4cvr1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1mou1pzu"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7IesZ))), {
                                    label: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                children: intl.formatMessage({
                                    id: "subnav.menu-back",
                                    defaultMessage: "Back"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _181n1txw _q8t51h6o",
                    "tablet-nav-company-logo"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                    href: mobileLogoHref,
                    "aria-label": mobileLogoAriaLabel,
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": mobileLogoDataEventContainer,
                    "data-product-key": productKey,
                    className: (0, $2jatx.default)([
                        "_4t3i183y"
                    ]),
                    children: mobileLogo
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4t3i1ylp _1e0c1txw _4cvr1h6o _181nglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    style: {
                        all: "unset"
                    },
                    "aria-label": intl.formatMessage({
                        id: "subnav.menu-icon.toggle",
                        defaultMessage: "Toggle Menu"
                    }),
                    className: (0, $2jatx.default)([
                        "_1e0cglyw _80omtlke _tnv2qshr _13jeglyw _7w28rbzz _1mjb1ule _xc2i12x7",
                        "subnavToggleMenu"
                    ]),
                    onClick: (e)=>{
                        e.preventDefault();
                        handleToggleMenu(!showMenu);
                        handleMenuPage("default");
                        handleFirstOpen(!showMenu);
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                        width: "18",
                        height: "11",
                        viewBox: "0 0 18 11",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        className: (0, $2jatx.default)([
                            "_v5644h09",
                            showMenu && "_t9ec1sub"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M17 1.86328L9 9.13601L1 1.86328",
                            stroke: "#101214",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                id: "nav-tablet-mobile-dropdown-menu-button",
                className: (0, $2jatx.default)([
                    "_1e0cglyw _181n1txw _q8t51h6o _1rqih2mm"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        style: {
                            all: "unset"
                        },
                        "aria-label": intl.formatMessage({
                            id: "subnav.menu-icon.toggle",
                            defaultMessage: "Toggle Menu"
                        }),
                        className: (0, $2jatx.default)([
                            "_1e0cglyw _80omtlke _tnv2qshr _13jeglyw _7w28rbzz _1mjb1ule _xc2i12x7",
                            "subnavToggleMenu"
                        ]),
                        onClick: (e)=>{
                            e.preventDefault();
                            handleToggleMenu(!showMenu);
                            handleMenuPage("default");
                            handleFirstOpen(!showMenu);
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                            width: "18",
                            height: "11",
                            viewBox: "0 0 18 11",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: (0, $2jatx.default)([
                                "_v5644h09",
                                showMenu && "_t9ec1sub"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M17 1.86328L9 9.13601L1 1.86328",
                                stroke: "#101214",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0cglyw _1lpykb7n _e7o81dj1 _12ho1osq _1d2yxilx _14b51ris _1rqistnw _1xlo1j15 _sfejpt1k _dwk3usvi _nv391wug _1bv01wug _1kkmgktf _z21jg2rd _nxbczf9h _6o24b4wl _1jb3u67f _1ocvidpf _1cac122b _1gw0zo7u _164f1ur6",
                            showMenu && "_181n1ule",
                            "mobile-dropdown-menu"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1pfhftgi _6rthftgi _1e0cglyw _1bah1y6m _4cvr1h6o",
                                    menuPage !== "default" && "_1e0c1txw"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                    style: {
                                        all: "unset"
                                    },
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        handleMenuPage("default");
                                        handleFirstOpen(false);
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_syazaqb7 _1e0c1txw _4cvr1h6o"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1mou1pzu"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7IesZ))), {
                                                    label: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                children: intl.formatMessage({
                                                    id: "subnav.menu-back",
                                                    defaultMessage: "Back"
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            tabletDropdownMenu
                        ]
                    })
                ]
            }),
            showMenu && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqsw1n9t _1e0c1ule _1bsb1osq _4t3i1osq _1e02idpf _rjxpidpf _u7coidpf _bfhk1ebw _1pby1mrw",
                    "overlay"
                ])
            })
        ]
    });
};

});




//# sourceMappingURL=agile-article.c7a2ea4e.js.map
